/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect } from "react";
import { useI18n } from "intl/useI18n";
import Tile from "./Tile.vue";
import { useDtfStore } from "../store";
import "./Sizes.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function Sizes({ ...restProps }) {
  const { n } = useI18n();
  const dtfStore = useDtfStore();

  function gangSheetBuilderSettings() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSettings' comes from an ... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderSettings;
  }

  function gangSheetBuilderSizes() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSizes' comes from an ind... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderSizes;
  }

  function gangSheetBulkPrice() {
    // @ts-expect-error TS(4111): Property 'gangSheetBulkPrice' comes from an index ... Remove this comment to see the full error message
    return dtfStore.gangSheetBulkPrice;
  }

  function sizes() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const bulkPrices = gangSheetBulkPrice()[gangSheetBuilderSettings().variantId]?.bulk_price;
    const sizesList: any = [];
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    gangSheetBuilderSizes().forEach((size: any) => {
      const sizeHeightFeet = Math.ceil(size.height / 12.0);
      const bulkPrice = bulkPrices?.find((price: any) => price.height === size.height);
      sizesList.push({
        label: `${sizeHeightFeet} Feet`,
        value: size.height,
        price: bulkPrice ? (bulkPrice.size_price * sizeHeightFeet).toFixed(2) : null,
        discount: bulkPrice?.percent_off
      });
    });
    return sizesList;
  }

  function updateGangSheetBuilderSettings(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateGangSheetBuilderSettings(...args);
  }

  function fetchBulkPrice(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.fetchBulkPrice(...args);
  }

  function handleTileSelected(value: any) {
    updateGangSheetBuilderSettings({
      height: value
    });
  }

  function fetchPrice() {
    fetchBulkPrice();
  }

  useEffect(() => {
    fetchPrice();
  }, []);

  return (
    <div {...restProps} className={cn("gang-sheet-builder-sizes")}>
      <span className={cn("gang-sheet-builder-sizes__title")}>
        {" "}
        Select size (all sizes are 22 inches wide){" "}
      </span>
      <div className={cn("gang-sheet-builder-sizes__tiles")}>
        {renderList(sizes(), size => (
          <div className={cn("gang-sheet-builder-sizes__tile")} key={size.value}>
            <Tile
              key={size.value}
              value={size}
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              isSelected={gangSheetBuilderSettings().height === size.value}
              onTileSelected={handleTileSelected}
              data-testid="tile"
            />
            <div className={cn("gang-sheet-builder-sizes__price")}>
              <div className={cn("gang-sheet-builder-sizes__price-value")}>
                {n(size.price, "currency")}
              </div>
              {size.discount > 0 ? (
                <div className={cn("gang-sheet-builder-sizes__price-discount")}>
                  {size.discount}% off{" "}
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
